import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithPwPrefix } from 'store/middleware/pwContextMiddleware';
import { WIDGET_API } from 'utils/constants';

import type { PayHubCashierContractsPaymentSessionStateResponse } from '../models';

export const sessionStateAPI = createApi({
  reducerPath: 'sessionStateAPI',
  baseQuery: createBaseQueryWithPwPrefix(WIDGET_API),
  endpoints(builder) {
    return {
      getPaymentsSessionState: builder.query<PayHubCashierContractsPaymentSessionStateResponse, void>({
        query: () => ({
          url: 'payments/session-state',
        }),
      }),
    };
  },
});

export const { useLazyGetPaymentsSessionStateQuery } = sessionStateAPI;
export default sessionStateAPI.reducer;
